exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\nNOTE:\nTHESE VARIABLES ARE HERE FOR THE SAKE OF COMPATIBILITY\nPLEASE USE THE ONES UNDER \"NEW NAMING\"\n*/\n\n/* NEW NAMING */\n\n/* families */\n\n/* size */\n\n/* General Indexes */\n\n/* Loading Layer */\n\n/* Component Indexes */\n\n/* Matching Pairs */\n\n/* Draw It */\n\n/* Global Transitions */\n\n.lesson_codes__wrapper--JYInI {\n}\n\n.lesson_codes__wrapper--JYInI .lesson_codes__subtitle--3dIzn {\n\t\tcolor: #5b6d79;\n\t\tfont-family: 'avenirroman', Helvetica, Arial, sans-serif;\n\t\tfont-size: 14px;\n\t\tmargin-bottom: 5px;\n\t\ttext-align: center;\n\t}\n\n.lesson_codes__btn-bar--3ykbg {\n}\n\n.lesson_codes__btn-bar--3ykbg .lesson_codes__btn-container--1K54c {\n\t\twidth: 140px;\n\t\tmargin: 0 auto;\n\t}\n", ""]);

// exports
exports.locals = {
	"wrapper": "lesson_codes__wrapper--JYInI",
	"subtitle": "lesson_codes__subtitle--3dIzn",
	"btn-bar": "lesson_codes__btn-bar--3ykbg",
	"btn-container": "lesson_codes__btn-container--1K54c"
};